<template>
   <div class="order-detail-view-wrapper order-detail-flight-view">
      <div class="order-detail-view-inner">
         <!--OldPnrInformations Information -->
         <OldPnrInformations :data="pnrObj.pnr" v-if="false" />

         <!--Reservation Information -->
         <ReservationInformation :data="pnrObj.pnr" :status="pnrObj.pnr.status" :show-reoption="ShowReoptionBtn" :packages="packages" />

         <!--Flight Information -->

         <FlightInformations :data="pnrObj.flights" />

         <!--Passenger Information -->
         <PassengerInformations :data="pnrObj.passengers" :grand-total="pnrObj" :packages="packages" />

         <!-- Order Detail Payment -->

         <PaymentPurchaseWidget
            entityType="flight"
            :entityId="pnrObj.pnr.id"
            :paymentChoiceDetail="PaymentChoiceDetail"
            @show="handlerShowWidget"
            v-if="$options.filters.EOdrType(packages.type) != $options.filters.EOdrType(5)" />

         <ModalView v-if="ModalStatus">
            <div><AncillariesAutomatedOffer :choices="AncillaryChoices" @handlerTrigger="listenTriggerKey" ref="automatedOffer" /></div>
         </ModalView>
         <!--Ancillaries-->

         <Ancillaries
            :hideModalPopup="hideModalPopup"
            :currency="pnrObj.currency"
            :pnr="pnrObj.pnr"
            :flights="pnrObj.flights"
            :passengers="pnrObj.passengers"
            :offer-trigger="ancillaryOfferKey"
            v-if="ShowAncillaries && reverseInqueryReqFinished"
            :ancillary-choices="AncillaryChoices"
            :onlineCheckInUrl="pnrObj.ancillaryChoices.onlineCheckinUrl" />
      </div>
   </div>
</template>

<script>
import OldPnrInformations from "@/components/structural/flight/order-detail/pnr-informations/OldPnrInformations.vue";
import ReservationInformation from "@/components/structural/flight/order-detail/pnr-informations/ReservationInfos.vue";
import FlightInformations from "@/components/structural/flight/order-detail/pnr-informations/FlightInformations.vue";
import PassengerInformations from "@/components/structural/flight/order-detail/pnr-informations/PassengerInformations.vue";
import PaymentPurchaseWidget from "@/components/structural/payment/PaymentPurchaseWidget.vue";
import Ancillaries from "@/components/structural/flight/order-detail/ancillaries/base/Ancillaries.vue";
import ModalView from "@/components/unitary/ModalView.vue";
import AncillariesAutomatedOffer from "@/components/structural/flight/order-detail/ancillaries/AncillariesAutomatedOffer.vue";

export default {
   name: "OrderDetailFlightView",
   props: {
      pnrProps: Object,
      packages: Object,
   },
   components: {
      OldPnrInformations,
      ReservationInformation,
      FlightInformations,
      PassengerInformations,
      PaymentPurchaseWidget,
      Ancillaries,
      ModalView,
      AncillariesAutomatedOffer,
   },
   data() {
      return {
         hideModalPopup: false,
         pnrObj: this.pnrProps,
         paymentChoices: this.pnrProps.paymentChoiceDetail.paymentChoices,
         ancillaryOfferKey: "",
         reverseInqueryReqFinished: false,
      };
   },
   mounted() {
      sessionStorage.removeItem("constantUuid");
   },
   computed: {
      AncillaryChoices() {
         return {
            ...this.pnrObj.ancillaryChoices,
            refund: this.$store.state.flight.reverseInqueryStatus?.[this.pnrProps.pnr.id]?.enabledReverseType,
         };
      },
      ModalStatus() {
         return this.$store.state.app.modalViewStatus.status;
      },

      ShowReoptionBtn() {
         return this.pnrObj.ancillaryChoices.reoption;
      },
      ShowAncillaries() {
         if (this.AncillaryChoices != undefined) {
            return Object.keys(this.AncillaryChoices).some((key) => {
               return this.AncillaryChoices[key] && key != "reoption";
            });
         } else {
            return false;
         }
      },
      ErrorId() {
         return this.$store.state.flight.ancillaryErrors.errorId;
      },
      PaymentChoiceDetail() {
         return this.pnrProps ? this.pnrProps.paymentChoiceDetail : null;
      },
   },
   methods: {
      listenTriggerKey(key) {
         this.ancillaryOfferKey = "";

         setTimeout(() => {
            if (key != "onlineCheckin") {
               this.$store.commit("app/setIsProgressGifActive", true);
            }

            this.ancillaryOfferKey = key;
            this.$store.commit("app/setModalViewStatus", { status: false, paymentRequired: false });
            this.$nextTick(() => {
               document.getElementById("ancillaries-container")?.scrollIntoView({ behavior: "smooth" });
            });
         }, 10);
      },

      handlerShowWidget(status) {
         status;
      },
   },
   watch: {
      "$store.state.flight.reverseInqueryStatus": {
         handler: function (reverseInqueryStatus) {
            this.reverseInqueryReqFinished = reverseInqueryStatus[this.pnrProps.pnr.id]?.status;
         },
         immediate: true,
         deep: true,
      },
      pnrProps: {
         handler: function (newPnrProps) {
            const self = this;
            self.pnrObj = newPnrProps;
            self.paymentChoices = newPnrProps.paymentChoices;
         },
         deep: true,
      },
      ShowAncillaries: {
         handler: function (status) {
            this.$store.state.app.modalViewStatus.showAncillaries = status;
         },
         immediate: true,
      },
      ErrorId: {
         handler: function (errorId) {
            if (errorId > 0) {
               this.$store.commit("app/setErrorId", errorId);
               this.hideModalPopup = true;
               this.$store.commit("app/setModalViewStatus", { status: true, paymentRequired: false });
               this.$store.state.app.modalViewStatus.showAncillaries = false;
               this.$nextTick(() => {
                  this.$refs.automatedOffer.manuelRequestTextArea = false;
                  this.$store.state.seatmap.pnr.status = false;
               });
            } else {
               this.$store.commit("app/setIsProgressGifActive", false);
               this.hideModalPopup = false;
            }
         },
      },
   },
};
</script>

<style lang="scss" scoped>
.order-detail-view-inner {
   > div {
      margin-bottom: 4rem;
   }
}
</style>
